const alignSelf = {
    name: "align-self",
    path: "/align-self",
    title: "align-self",
    description: "Utilities for controlling how an individual grid item is aligned along its block axis.",
    value: {
        "align-self": {
            "self-auto": "auto",
            "self-start": "flex-start",
            "self-end": "flex-end",
            "self-end-safe": "safe flex-end",
            "self-center": "center",
            "self-center-safe": "safe center",
            "self-stretch": "stretch",
            "self-baseline": "baseline",
            "self-baseline-last": "last baseline",
        },
    },
    exampleData: [
        {
            "example": {
                "code": `
<div class="grid grid-columns-3 h-32 items-stretch gap-4">
  <div class="bg-color-pink-500 text-white p-2 h-8 self-start">01 (start)</div>
  <div class="bg-color-pink-500 text-white p-2 h-16 self-end">02 (end)</div>
  <div class="bg-color-pink-500 text-white p-2 h-12 self-center">03 (center)</div>
</div>

<div class="grid grid-columns-3 h-32 items-stretch gap-4 mt-6">
  <div class="bg-color-pink-500 text-white p-2 h-8 self-stretch">01 (stretch)</div>
  <div class="bg-color-pink-500 text-white p-2 h-16 self-baseline">02 (baseline)</div>
  <div class="bg-color-pink-500 text-white p-2 h-12 self-baseline-last">03 (last baseline)</div>
</div>
                `
            },
        },
    ],
    htmlData: [
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
                Use <code class="text-color-gray-800 dark:text-color-white font-semibold">self-*</code> utilities to control how an individual grid item is aligned along its block axis.
            </p>
            <div class="space-y-10">
                <div>
                    <small class="text-center block mb-4">self-start / self-end / self-center</small>
                    <div class="relative h-32">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-full gap-4 items-stretch font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center flex justify-center items-center  rounded-lg h-8 self-start">01 (start)</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center flex justify-center items-center  rounded-lg h-16 self-end">02 (end)</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center flex justify-center items-center  rounded-lg h-12 self-center">03 (center)</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">self-stretch / self-baseline / self-baseline-last</small>
                    <div class="relative h-32">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-full gap-4 items-stretch font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center flex justify-center items-center  rounded-lg h-8 self-stretch">01 (stretch)</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center flex justify-center items-center  rounded-lg h-16 self-baseline">02 (baseline)</div>
                            <div class="bg-color-pink-500 p-2 flex justify-center items-center flex justify-center items-center  rounded-lg h-12 self-baseline-last">03 (last baseline)</div>
                        </div>
                    </div>
                </div>
            </div>
            `
        },
    ]
}

export default alignSelf;

<div className="sr-only">
    <div class="space-y-10">
                <div>
                    <small class="text-center block mb-4">self-start / self-end / self-center</small>
                    <div class="relative h-32">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-full gap-4 items-stretch font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 p-2 rounded-lg h-8 self-start">01 (start)</div>
                            <div class="bg-color-pink-500 p-2 rounded-lg h-16 self-end">02 (end)</div>
                            <div class="bg-color-pink-500 p-2 rounded-lg h-12 self-center">03 (center)</div>
                        </div>
                    </div>
                </div>
                <div>
                    <small class="text-center block mb-4">self-stretch / self-baseline / self-baseline-last</small>
                    <div class="relative h-32">
                        <div class="absolute inset-0 z-0">
                            <div class="h-full rounded-lg border bg-size-[8px_8px] text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)] border border-color-gray-200 rounded-lg dark:border-color-gray-700"></div>
                        </div>
                        <div class="grid grid-columns-3 h-full gap-4 items-stretch font-mono text-sm leading-6 font-bold text-color-white relative">
                            <div class="bg-color-pink-500 flex justify-center items-center p-2 rounded-lg h-8 self-stretch">01 (stretch)</div>
                            <div class="bg-color-pink-500 p-2 rounded-lg h-16 self-baseline">02 (baseline)</div>
                            <div class="bg-color-pink-500 p-2 rounded-lg h-12 self-baseline-last">03 (last baseline)</div>
                        </div>
                    </div>
                </div>
            </div>
</div>